
import { defuFn } from '/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/nuxt-core/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
